<script>
import lang from "@/directives/lang";

export default {
  name: "ArticleContentExample",
  directives: {
    lang
  },
  props: {
    l1Eks: {
      type: String,
      default: undefined
    },
    l2Eks: {
      type: String,
      default: undefined
    }
  }
};
</script>

<template>
  <div class="indentation-container">
    <span v-lang:source class="article-content__text">{{ l1Eks }}</span>
    <span v-if="l2Eks">
      <span
        class="article-content__translation-separator article-content__translation-separator--small"
        >&raquo;</span
      >
      <span v-lang:target class="article-content__text article-content__text--primary">{{
        l2Eks
      }}</span>
    </span>
  </div>
</template>
